type Separator = 'à' | '-';

type FormatShortDateStringProps = {
	firstDate?: Date;
	separator?: Separator;
	secondDate?: Date;
	lang?: string;
};

export function formatShortDateString({
	firstDate,
	separator,
	secondDate,
	lang = 'pt-BR',
}: FormatShortDateStringProps) {
	if (!firstDate) {
		return undefined;
	}
	const formattedFirstDate = firstDate.toLocaleString(lang, {dateStyle: 'short'});

	if (secondDate) {
		const formattedSecondDate = secondDate.toLocaleString(lang, {dateStyle: 'short'});
		return `${formattedFirstDate} ${separator} ${formattedSecondDate}`;
	}

	return formattedFirstDate;
}
